<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <div class="container">
      <div class="row">
        <div class="col">
          <app-styled-header-box
            [text]="t('live.results.race.header.title')">
          </app-styled-header-box>
        </div>
      </div>
    </div>
    <ng-template [ngTemplateOutlet]="results"></ng-template>
  </app-page-template>

  <ng-template #results>
    <section class="upper-section-background">
      <div class="container pb-300-100">
        <div class="row row-cols-1">
          @if (liveEvents.length > 0) {
            <div>
              @for (liveEvent of liveEvents; track liveEvent) {
                <div>
                  <app-live-event [liveEvent]="liveEvent" [languages]="languages" [countries]="countries"/>
                </div>
              }
            </div>
          } @else {
            <app-empty-state-live/>
          }
        </div>
      </div>
    </section>
  </ng-template>
</ng-container>
